import React, {PropsWithChildren} from "react";
import "./ButtonGroup.css";

interface Props {
  vertical?: boolean;
}

export const ButtonGroup = ({vertical = false, children}: PropsWithChildren<Props>) => {
  const classes = "button-group" + (vertical ? " vertical" : "");
  return (
      <div className={classes}>
        {children}
      </div>
  )
};